import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postServiceProducts = async ({ serviceId, products }: JsonDataItem) => {
  const { data } = await baseQuery('service-product', {
    type: 'POST',
    body: {
      service_id: serviceId,
      products,
    },
  });

  return data;
};
